import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  Button,
  TextInput,
  Grid,
  Table,
  Text,
  ActionIcon,
  Group,
  Textarea,
  Checkbox,
  Tooltip,
} from "@mantine/core";
import ReactJson from "react-json-view";
import { useForceUpdate } from "@mantine/hooks";
import {
  IconCirclePlus,
  IconExchange,
  IconMultiplier1x,
  IconTrash,
} from "@tabler/icons";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import ArrayTable from "./arrayTable";
import TemplateSaveLoadButtons from "./templateSaveLoadButtons";

const CopyToDnCheckbox = ({ checked, ...props }) => (
  <Tooltip label="Copy to debitnote" withArrow position="top">
    <span>
      <Checkbox {...props} checked={checked !== false} />
    </span>
  </Tooltip>
);

const QuotationDescription = ({
  form,
  name,
  readonly = false,
  enablePageBreak = false,
  enableCopyToDn = true,
}) => {
  const description = _.get(form.values, name) || [];
  const rowInitValue = {
    title: "",
    detail: "",
    ...(enableCopyToDn ? { copyToDN: false } : {}),
  };

  const fields = [
    {
      header: "Title",
      headerWidth: "20%",
      fieldName: "title",
      component: TextInput,
      props: {},
    },
    {
      header: "Detail",
      headerWidth: enableCopyToDn ? "60%" : "65%",
      fieldName: "detail",
      component: Textarea,
      props: {
        minRows: 1,
        autosize: true,
        py: 0,
      },
    },
  ];

  if (enableCopyToDn) {
    fields.push({
      header: "DN",
      headerWidth: "8%",
      headerTooltip: "Copy to debitnote",
      headerCheckbox: true,
      headerCheckboxTooltip: "Check / uncheck all",
      headerCheckedIf: (value) => value !== false,
      fieldName: "copyToDN",
      type: "checkbox",
      component: CopyToDnCheckbox,
      props: {
        type: "checkbox",
      },
    });
  }

  const loadFromTemplate = (template) => {
    form.setFieldValue(name, template.content ?? []);
  };

  return (
    <>
      {!readonly && (
        <TemplateSaveLoadButtons
          form={form}
          name={name}
          templateCategory="Quotation Description"
          onLoadTemplate={loadFromTemplate}
          currentContent={description}
          mb={"sm"}
        />
      )}

      <ArrayTable
        form={form}
        name={name}
        rowInitValue={rowInitValue}
        fields={fields}
        readonly={readonly}
        enablePageBreak={enablePageBreak}
      />
    </>
  );
};

export default QuotationDescription;
